export interface IDataSetMyMillInformation {
    /**
     * Date of when MyMill extracted the date from machines
     */
    extractionDate: string;
    /**
     * Date of when the MyMill import was created
     */
    importDate?: string;
}

export class DataSetMyMillInformation implements IDataSetMyMillInformation {
    public extractionDate: string;
    public importDate?: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: DataSetMyMillInformation);
    constructor(obj?: any) {
        this.extractionDate = (obj && obj.extractionDate) || '';
        if (obj && obj.importDate) {
            this.importDate = obj.importDate;
        }
    }
}
